import { Button, Modal } from "react-bootstrap";

type Props = {
  title: string;
  showModal: boolean;
  setShowModal: (val: boolean) => void;
  onDelete: () => void;
}

export function DeleteModal({
  title,
  showModal,
  setShowModal,
  onDelete,
}: Props): JSX.Element {
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{title} Removal</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>This cannot be undone. Are you sure to want to remove this {title}?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setShowModal(false);
              onDelete();
            }}
          >
            Remove {title}
          </Button>
        </Modal.Footer>
      </Modal>
  );
}